import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { take } from 'rxjs';

import { IFilterNumber } from '@shared/models/graphql';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import { setUnsavedYearBuiltFiltersAction } from '@state/filters/filters.actions';
import { selectFiltersCurrent } from '@state/filters/filters.selectors';

@UntilDestroy()
@Component({
  selector: 'app-filter-v2-year-built',
  templateUrl: './filter-v2-year-built.component.html',
  styleUrls: [
    './filter-v2-year-built.component.scss',
    '../filters-v2.component.scss',
  ],
})
export class FilterV2YearBuiltComponent implements OnInit {
  public minValue: number | null = null;
  public maxValue: number | null = null;

  protected options = Array.from(
    { length: new Date().getFullYear() - 1900 },
    (_, i) => new Date().getFullYear() - i
  );

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.loadInitialValue();

    // for clearing the filters
    this.store
      .select(selectFiltersCurrent)
      .pipe(untilDestroyed(this))
      .subscribe((filters) => {
        if (
          !filters?.yearBuilt ||
          (!filters.yearBuilt.greaterThanOrEqual &&
            !filters.yearBuilt.lessThanOrEqual)
        ) {
          this.minValue = null;
          this.maxValue = null;
        }
      });
  }

  handleChange() {
    if (
      this.minValue &&
      this.maxValue &&
      this.minValue > this.maxValue &&
      this.maxValue > 0
    ) {
      this.maxValue = this.minValue;
    }

    let yearBuiltQuery: IFilterNumber = {};
    if (this.minValue && this.minValue > 0) {
      yearBuiltQuery.greaterThanOrEqual = Number(this.minValue);
    }
    if (this.maxValue && this.maxValue > 0) {
      yearBuiltQuery.lessThanOrEqual = Number(this.maxValue);
    }

    this.store.dispatch(setUnsavedYearBuiltFiltersAction(yearBuiltQuery));
  }

  loadInitialValue() {
    this.store
      .select(selectFiltersCurrent)
      .pipe(take(1))
      .subscribe((filters) => {
        if (filters?.yearBuilt) {
          if (filters.yearBuilt.greaterThanOrEqual) {
            this.minValue = Number(filters.yearBuilt.greaterThanOrEqual);
          } else {
            this.minValue = null;
          }
          if (filters.yearBuilt.lessThanOrEqual) {
            this.maxValue = Number(filters.yearBuilt.lessThanOrEqual);
          } else {
            this.maxValue = null;
          }
        } else {
          this.minValue = null;
          this.maxValue = null;
        }
      });
  }

  selectAll(event: FocusEvent): void {
    const input = event.target as HTMLInputElement;
    input.addEventListener('contextmenu', (e) => {
      e.preventDefault();
    });
    input.select();
  }
}
